import interceptor from 'rest/interceptor';
import { isLegacyIE } from '../../utils/generalUtils';

const ieCacheBuster = interceptor({
    request: (request, config, meta) => {
        const cacheBuster = Date.now();

        // 💩cache bust because IE sucks and doesn't respect headers 💩
        if (isLegacyIE()) {
            if (request.path.includes('?')) {
                request.path = `${request.path}&cacheBuster=${cacheBuster}`;
            } else {
                request.path = `${request.path}?cacheBuster=${cacheBuster}`;
            }

            if(request.path.includes('misl')) {
                request.path = request.path.replace('cacheBuster', 'fields');
            }
        }

        return request;
    }
});

export default ieCacheBuster;
